import builder from '../builder';
import MultipleActionsAdd from '../../streamline-icons/light/multiple-actions-add.svg';

export default builder('IconMultipleActionsAddLight', MultipleActionsAdd);
